// Anabiya Decor — full catalogue + storefront data.

const IMG = {
  bedding_main:
    "https://images.unsplash.com/photo-1616594092403-fb65629b0a46?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBiZWRyb29tJTIwYmVkZGluZ3xlbnwwfHx8fDE3ODU4NDIwMzh8MA&ixlib=rb-4.1.0&q=85",
  cushions:
    "https://images.unsplash.com/photo-1623944431758-e856760d7b65?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBiZWRyb29tJTIwYmVkZGluZ3xlbnwwfHx8fDE3ODU4NDIwMzh8MA&ixlib=rb-4.1.0&q=85",
  curtains:
    "https://images.unsplash.com/photo-1754611380518-61a923cc47ca?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxNzV8MHwxfHNlYXJjaHwzfHxlbGVnYW50JTIwbGl2aW5nJTIwcm9vbSUyMGN1cnRhaW5zfGVufDB8fHx8MTc4NTg0MjAzOHww&ixlib=rb-4.1.0&q=85",
  linen:
    "https://images.unsplash.com/photo-1596433904500-97b901c5d274?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHwyfHxmb2xkZWQlMjBwcmVtaXVtJTIwbGluZW58ZW58MHx8fHwxNzg1ODQyMDM4fDA&ixlib=rb-4.1.0&q=85",
  craft:
    "https://images.unsplash.com/photo-1675176785803-bffbbb0cd2f4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTV8MHwxfHNlYXJjaHwxfHx0ZXh0aWxlJTIwY3JhZnQlMjBtYW51ZmFjdHVyaW5nfGVufDB8fHx8MTc4NTg0MjAzOHww&ixlib=rb-4.1.0&q=85",
  bedroom_a: "https://images.unsplash.com/photo-1505693416388-ac5ce068fe85?auto=format&fit=crop&w=1600&q=80",
  bedroom_b: "https://images.unsplash.com/photo-1522771739844-6a9f6d5f14af?auto=format&fit=crop&w=1600&q=80",
  bedroom_c: "https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?auto=format&fit=crop&w=1600&q=80",
  bedroom_d: "https://images.unsplash.com/photo-1540518614846-7eded433c457?auto=format&fit=crop&w=1600&q=80",
  bedroom_e: "https://images.unsplash.com/photo-1616486338812-3dadae4b4ace?auto=format&fit=crop&w=1600&q=80",
  living_a: "https://images.unsplash.com/photo-1567016376408-0226e4d0c1ea?auto=format&fit=crop&w=1600&q=80",
  living_b: "https://images.unsplash.com/photo-1493663284031-b7e3aefcae8e?auto=format&fit=crop&w=1600&q=80",
  bath_a: "https://images.unsplash.com/photo-1552321554-5fefe8c9ef14?auto=format&fit=crop&w=1600&q=80",
  bath_b: "https://images.unsplash.com/photo-1600494603989-9650cf6dad51?auto=format&fit=crop&w=1600&q=80",
  towel_a: "https://images.unsplash.com/photo-1583845112203-29329902332e?auto=format&fit=crop&w=1600&q=80",
  duvet_a: "https://images.unsplash.com/photo-1631049035182-249067d7618e?auto=format&fit=crop&w=1600&q=80",
  duvet_b: "https://images.unsplash.com/photo-1584100936595-c0654b55a2e2?auto=format&fit=crop&w=1600&q=80",
  runner_a: "https://images.unsplash.com/photo-1519710164239-da123dc03ef4?auto=format&fit=crop&w=1600&q=80",
  cushion_b: "https://images.unsplash.com/photo-1616627451515-8b0b8e6f6b78?auto=format&fit=crop&w=1600&q=80",
  cushion_c: "https://images.unsplash.com/photo-1595526114035-0d45ed16cfbf?auto=format&fit=crop&w=1600&q=80",
  bench: "https://images.unsplash.com/photo-1618221118493-9cfa1a1c00da?auto=format&fit=crop&w=1600&q=80",
  bolster: "https://images.unsplash.com/photo-1631679706909-1844bbd07221?auto=format&fit=crop&w=1600&q=80",
  bedspread: "https://images.unsplash.com/photo-1522708323590-d24dbb6b0267?auto=format&fit=crop&w=1600&q=80",
  round: "https://images.unsplash.com/photo-1585909695284-32d2985ac9c0?auto=format&fit=crop&w=1600&q=80",
};

export const CONTACT_INFO = {
  brand: "Anabiya Decor",
  tagline: "Premium Home Décor & Bedding Manufacturer",
  city: "Mumbai, India",
  address: "Bhiwandi Textile Hub, Mumbai, Maharashtra 421302, India",
  phone: "+91 91374 62428",
  phoneRaw: "+919137462428",
  whatsapp: "919137462428",
  email: "anabiyadecorhelp@gmail.com",
  hours: "Mon – Sat · 10:00 – 19:00 IST",
  socials: {
    instagram: "https://instagram.com/anabiyadecor786",
    facebook: "https://facebook.com/",
    linkedin: "https://linkedin.com/",
    pinterest: "https://pinterest.com/",
  },
};

// Storefront categories (with landing tiles for Shop By Category grid)
export const CATEGORIES = [
  { slug: "duvet-covers", label: "Duvet Covers", image: IMG.duvet_a },
  { slug: "sheet-sets", label: "Sheet Sets", image: IMG.bedding_main },
  { slug: "quilts-bedspreads", label: "Quilts", image: IMG.bedspread },
  { slug: "curtains", label: "Curtains", image: IMG.curtains },
  { slug: "bath", label: "Towels & Robes", image: IMG.bath_a },
  { slug: "monogram-bedding", label: "Monogram Bedding", image: IMG.duvet_b },
  { slug: "headboards", label: "Headboards", image: IMG.bedroom_e },
  { slug: "pillow-covers", label: "Pillow Covers", image: IMG.cushions },
  { slug: "cushion-covers", label: "Cushion Covers", image: IMG.cushion_b },
  { slug: "custom-bedding", label: "Custom Bedding", image: IMG.bedding_main },
  { slug: "sofa-covers", label: "Sofa Covers", image: IMG.living_a },
  { slug: "bedskirts", label: "Bedskirts", image: IMG.bedroom_c },
  { slug: "handmade-bags", label: "Handmade Bags", image: IMG.craft },
  { slug: "handmade-gifts", label: "Handmade Gifts", image: IMG.cushion_c },
  { slug: "personalised-gifts", label: "Personalised Gifts", image: IMG.bath_a },
  { slug: "custom-gifts", label: "Custom Gifts", image: IMG.cushions },
  { slug: "winter-jackets", label: "Winter Jackets", image: IMG.bedspread },
  { slug: "linen-dresses", label: "Linen Dresses", image: IMG.linen },
  { slug: "throws-blankets", label: "Throws & Blankets", image: IMG.bedspread },
  { slug: "hotel-bedding", label: "Hotel Bedding", image: IMG.linen },
  { slug: "monogrammed-tshirts", label: "Monogrammed T-Shirts", image: IMG.linen },
  { slug: "bench-cushions", label: "Bench Cushions", image: IMG.bench },
  { slug: "personalised-jewellery", label: "Personalised Jewellery", image: IMG.craft },
  { slug: "personalised-bags", label: "Personalised Bags", image: IMG.craft },
];

// Filter labels for the shop page
export const FILTER_TABS = [
  { slug: "all", label: "All" },
  { slug: "duvet-covers", label: "Duvet Covers" },
  { slug: "sheet-sets", label: "Sheet Sets" },
  { slug: "comforters", label: "Comforters" },
  { slug: "quilts-bedspreads", label: "Quilts" },
  { slug: "pillow-covers", label: "Pillow Covers" },
  { slug: "cushion-covers", label: "Cushion Covers" },
  { slug: "curtains", label: "Curtains" },
  { slug: "bath", label: "Towels & Robes" },
  { slug: "monogram-bedding", label: "Monogram Bedding" },
  { slug: "headboards", label: "Headboards" },
  { slug: "custom-bedding", label: "Custom Bedding" },
  { slug: "sofa-covers", label: "Sofa Covers" },
  { slug: "bedskirts", label: "Bedskirts" },
  { slug: "handmade-bags", label: "Handmade Bags" },
  { slug: "handmade-gifts", label: "Handmade Gifts" },
  { slug: "personalised-gifts", label: "Personalised Gifts" },
  { slug: "custom-gifts", label: "Custom Gifts" },
  { slug: "winter-jackets", label: "Winter Jackets" },
  { slug: "linen-dresses", label: "Linen Dresses" },
  { slug: "throws-blankets", label: "Throws & Blankets" },
  { slug: "kitchen-dining", label: "Kitchen & Dining" },
  { slug: "rugs-mats", label: "Rugs & Mats" },
  { slug: "baby-kids", label: "Baby & Kids" },
  { slug: "hotel-bedding", label: "Hotel Bedding" },
  { slug: "accents", label: "Accents" },
  { slug: "monogrammed-tshirts", label: "Monogrammed T-Shirts" },
  { slug: "bench-cushions", label: "Bench Cushions" },
  { slug: "personalised-jewellery", label: "Personalised Jewellery" },
  { slug: "personalised-bags", label: "Personalised Bags" },
];

const inr = (n) => n; // helper if we later want to compute

// 30 products — kept intentionally rich but concise
export const PRODUCTS = [
  {
    slug: "bamboo-border-embroidered-duvet-set",
    title: "Bamboo Border Embroidered Duvet Set",
    tag: "New",
    category: "duvet-covers",
    price: inr(6499),
    mrp: 9200,
    caption: "Nature's Geometry · 400 TC Sateen",
    description:
      "A quiet homage to bamboo groves — hand-guided embroidery on 400 TC long-staple sateen, finished with mother-of-pearl closures. Includes duvet cover + two pillow shams.",
    material: "100% Long-staple Cotton, 400 TC Sateen",
    care: "Cold machine wash · Tumble low · Warm iron reverse",
    sizes: ["Single", "Double", "Queen", "King"],
    colours: [
      { name: "Ivoire", hex: "#EEE7DA" },
      { name: "Forest", hex: "#1E4F35" },
      { name: "Ochre", hex: "#C79B4A" },
    ],
    images: [IMG.duvet_a, IMG.bedding_main, IMG.bedroom_a, IMG.linen],
    rating: 4.9,
    reviewCount: 128,
    featured: true,
  },
  {
    slug: "ivoire-sateen-sheet-set",
    title: "Ivoire Sateen Sheet Set",
    tag: "Bestseller",
    category: "sheet-sets",
    price: 4299,
    mrp: 5900,
    caption: "400 TC Cotton Sateen",
    description:
      "Our signature sateen with a mirror-smooth hand feel. Set includes flat sheet, deep-pocket fitted sheet, and two pillowcases.",
    material: "100% Cotton, 400 TC Sateen",
    care: "Machine wash cold · Tumble dry low",
    sizes: ["Single", "Double", "Queen", "King"],
    colours: [
      { name: "Ivoire", hex: "#EEE7DA" },
      { name: "Slate", hex: "#4C5B5C" },
      { name: "Rose", hex: "#D6B5B0" },
    ],
    images: [IMG.bedding_main, IMG.duvet_b, IMG.bedroom_b],
    rating: 4.8,
    reviewCount: 214,
    featured: true,
  },
  {
    slug: "percale-crisp-sheet-set",
    title: "Percale Crisp Sheet Set",
    category: "sheet-sets",
    price: 3599,
    mrp: 4700,
    caption: "300 TC Percale · Cool touch",
    description:
      "Cool, crisp and hotel-fresh. Percale weave for a matte, breathable finish that softens with every wash.",
    material: "100% Cotton, 300 TC Percale",
    care: "Machine wash cold",
    sizes: ["Single", "Double", "Queen", "King"],
    colours: [
      { name: "Snow", hex: "#F7F5EE" },
      { name: "Sage", hex: "#B9C4AC" },
    ],
    images: [IMG.bedroom_b, IMG.linen, IMG.duvet_a],
    rating: 4.7,
    reviewCount: 96,
  },
  {
    slug: "monogram-classic-duvet-cover",
    title: "Monogram Classic Duvet Cover",
    tag: "Custom",
    category: "duvet-covers",
    price: 5999,
    mrp: 7900,
    caption: "Bespoke monogram · Sateen",
    description:
      "Add your initials or house name — chain-stitched on the corner. Turnaround: 5–7 working days.",
    material: "100% Cotton, 400 TC Sateen",
    care: "Machine wash cold, gentle cycle",
    sizes: ["Single", "Double", "Queen", "King"],
    colours: [
      { name: "Ivoire", hex: "#EEE7DA" },
      { name: "Sand", hex: "#D9C7A7" },
    ],
    images: [IMG.duvet_b, IMG.bedroom_a, IMG.bedding_main],
    rating: 4.9,
    reviewCount: 54,
    featured: true,
  },
  {
    slug: "ivoire-baffle-box-comforter",
    title: "Ivoire Baffle-box Comforter",
    category: "comforters",
    price: 5499,
    mrp: 7200,
    caption: "Microfibre fill · Baffle-box",
    description:
      "Even loft, no cold spots. Baffle-box construction with hypoallergenic microfibre fill and sateen shell.",
    material: "Cotton shell + hypoallergenic microfibre fill",
    care: "Spot clean or professional dry clean",
    sizes: ["Single", "Double", "Queen", "King"],
    colours: [{ name: "Ivoire", hex: "#EEE7DA" }],
    images: [IMG.bedroom_a, IMG.duvet_a, IMG.bedding_main],
    rating: 4.7,
    reviewCount: 71,
  },
  {
    slug: "goose-down-alternative-comforter",
    title: "Down-alternative Comforter",
    category: "comforters",
    price: 6899,
    mrp: 8900,
    caption: "All-season · Baffle stitch",
    description:
      "Cloud-like drape with the warmth of down and none of the allergens. Reinforced piped edges.",
    material: "Cotton shell + microfibre down-alternative fill",
    care: "Professional cleaning recommended",
    sizes: ["Double", "Queen", "King"],
    colours: [{ name: "Ivoire", hex: "#EEE7DA" }],
    images: [IMG.duvet_a, IMG.bedroom_a, IMG.linen],
    rating: 4.8,
    reviewCount: 43,
  },
  {
    slug: "handstitched-cotton-quilt",
    title: "Handstitched Cotton Quilt",
    tag: "Handmade",
    category: "quilts-bedspreads",
    price: 4199,
    mrp: 5300,
    caption: "All-season · Reversible",
    description:
      "Hand-guided kantha-inspired stitching on breathable cotton — reversible ivory/sage.",
    material: "100% Cotton shell + cotton fill",
    care: "Machine wash cold, gentle",
    sizes: ["Single", "Double", "Queen"],
    colours: [
      { name: "Ivory / Sage", hex: "#B9C4AC" },
      { name: "Sand / Forest", hex: "#1E4F35" },
    ],
    images: [IMG.bedspread, IMG.bedroom_b, IMG.bedroom_c],
    rating: 4.8,
    reviewCount: 62,
  },
  {
    slug: "cotton-classic-bedspread",
    title: "Cotton Classic Bedspread",
    category: "quilts-bedspreads",
    price: 3299,
    mrp: 4500,
    caption: "Lightweight · Coverlet",
    description:
      "Soft, easy layering. Perfect over a bed or thrown across a sofa on rainy afternoons.",
    material: "100% Cotton",
    care: "Machine wash cold",
    sizes: ["Double", "Queen", "King"],
    colours: [
      { name: "Snow", hex: "#F7F5EE" },
      { name: "Sand", hex: "#D9C7A7" },
      { name: "Forest", hex: "#1E4F35" },
    ],
    images: [IMG.bedspread, IMG.bedroom_c, IMG.duvet_b],
    rating: 4.6,
    reviewCount: 39,
  },
  {
    slug: "velvet-cushion-cover-pair",
    title: "Velvet Cushion Covers (Set of 2)",
    tag: "Pair",
    category: "pillow-covers",
    price: 1499,
    mrp: 2100,
    caption: "18\"×18\" · Piped edges",
    description:
      "Deep, plush velvet with fine piped edges. Pack of two — mix or match colourways.",
    material: "Polyester Velvet · Cotton back",
    care: "Cold hand wash",
    sizes: ["16×16", "18×18", "20×20", "24×24"],
    colours: [
      { name: "Forest", hex: "#1E4F35" },
      { name: "Ochre", hex: "#C79B4A" },
      { name: "Bone", hex: "#EEE7DA" },
      { name: "Wine", hex: "#5B1A2A" },
    ],
    images: [IMG.cushions, IMG.cushion_b, IMG.cushion_c],
    rating: 4.9,
    reviewCount: 187,
    featured: true,
  },
  {
    slug: "linen-cushion-cover-pair",
    title: "Stonewashed Linen Cushions (Set of 2)",
    category: "pillow-covers",
    price: 1699,
    mrp: 2300,
    caption: "18\"×18\" · Fringe trim",
    description:
      "Softly rumpled stonewashed linen with a tonal fringe — quietly luxurious.",
    material: "100% Linen · Cotton back",
    care: "Cold machine wash",
    sizes: ["18×18", "20×20", "24×24"],
    colours: [
      { name: "Sand", hex: "#D9C7A7" },
      { name: "Slate", hex: "#4C5B5C" },
      { name: "Rose", hex: "#D6B5B0" },
    ],
    images: [IMG.cushion_b, IMG.cushions, IMG.bedroom_e],
    rating: 4.7,
    reviewCount: 84,
  },
  {
    slug: "jacquard-euro-sham",
    title: "Jacquard Euro Sham",
    category: "pillow-covers",
    price: 1899,
    mrp: 2600,
    caption: "26\"×26\" · Woven pattern",
    description:
      "Woven jacquard with a subtle tonal motif. Great for European-style layering at the headboard.",
    material: "Cotton-blend Jacquard",
    care: "Machine wash cold",
    sizes: ["26×26"],
    colours: [
      { name: "Bone", hex: "#EEE7DA" },
      { name: "Forest", hex: "#1E4F35" },
    ],
    images: [IMG.cushion_c, IMG.cushions, IMG.duvet_b],
    rating: 4.6,
    reviewCount: 27,
  },
  {
    slug: "blackout-pinch-pleat-curtains",
    title: "Blackout Pinch-Pleat Curtains",
    tag: "Custom drops",
    category: "curtains",
    price: 3899,
    mrp: 5200,
    caption: "Room darkening · Thermal lining",
    description:
      "Pinch-pleat headers with a triple-weave blackout core. Custom heights up to 108\".",
    material: "Cotton-blend + thermal blackout lining",
    care: "Dry clean recommended",
    sizes: ["54×84", "54×96", "54×108", "Custom"],
    colours: [
      { name: "Sand", hex: "#D9C7A7" },
      { name: "Charcoal", hex: "#33383B" },
      { name: "Forest", hex: "#1E4F35" },
    ],
    images: [IMG.curtains, IMG.living_a, IMG.bedroom_c],
    rating: 4.8,
    reviewCount: 132,
    featured: true,
  },
  {
    slug: "sheer-linen-curtains",
    title: "Sheer Linen Curtains",
    category: "curtains",
    price: 2799,
    mrp: 3600,
    caption: "Rod-pocket · Airy drape",
    description:
      "A whisper of linen at your window — light-filtering, breeze-catching, floor-skimming.",
    material: "100% Linen",
    care: "Cold delicate wash",
    sizes: ["54×84", "54×96", "54×108"],
    colours: [
      { name: "Bone", hex: "#EEE7DA" },
      { name: "Sand", hex: "#D9C7A7" },
    ],
    images: [IMG.curtains, IMG.bedroom_d, IMG.living_b],
    rating: 4.7,
    reviewCount: 58,
  },
  {
    slug: "ticking-stripe-border-curtains",
    title: "Ticking Stripe Border Curtains",
    category: "curtains",
    price: 3299,
    mrp: 4200,
    caption: "Cotton · Custom sizes",
    description:
      "A classic ticking stripe finished with a wide contrast border — quiet, considered.",
    material: "100% Cotton",
    care: "Machine wash cold",
    sizes: ["54×84", "54×96", "54×108", "Custom"],
    colours: [
      { name: "Bone / Forest", hex: "#1E4F35" },
      { name: "Bone / Charcoal", hex: "#33383B" },
    ],
    images: [IMG.living_a, IMG.curtains, IMG.bedroom_c],
    rating: 4.8,
    reviewCount: 46,
  },
  {
    slug: "waffle-bath-towel-set",
    title: "Waffle Bath Towel Set (Set of 4)",
    tag: "Set",
    category: "bath",
    price: 2999,
    mrp: 3900,
    caption: "600 GSM · Waffle weave",
    description:
      "Absorbent, quick-drying waffle-weave towels. Set includes 2 bath, 1 hand, 1 face.",
    material: "100% Cotton, 600 GSM",
    care: "Machine wash warm",
    sizes: ["Set of 4"],
    colours: [
      { name: "Bone", hex: "#EEE7DA" },
      { name: "Sage", hex: "#B9C4AC" },
      { name: "Charcoal", hex: "#33383B" },
    ],
    images: [IMG.towel_a, IMG.bath_a, IMG.bath_b],
    rating: 4.9,
    reviewCount: 210,
    featured: true,
  },
  {
    slug: "monogram-bath-robe",
    title: "Monogram Bath Robe",
    tag: "Custom",
    category: "bath",
    price: 3599,
    mrp: 4600,
    caption: "Waffle robe · Chain-stitched initials",
    description:
      "Lightweight waffle-weave robe with a shawl collar. Add up to three initials.",
    material: "100% Cotton",
    care: "Machine wash warm",
    sizes: ["S", "M", "L", "XL"],
    colours: [
      { name: "Bone", hex: "#EEE7DA" },
      { name: "Slate", hex: "#4C5B5C" },
    ],
    images: [IMG.bath_a, IMG.towel_a, IMG.bath_b],
    rating: 4.8,
    reviewCount: 68,
  },
  {
    slug: "plush-bath-sheet",
    title: "Plush Bath Sheet",
    category: "bath",
    price: 1499,
    mrp: 2100,
    caption: "700 GSM · Extra-large",
    description:
      "A wrap-around plush bath sheet in dense loop cotton — spa-soft.",
    material: "100% Cotton, 700 GSM",
    care: "Machine wash warm",
    sizes: ["36×72"],
    colours: [
      { name: "Bone", hex: "#EEE7DA" },
      { name: "Sand", hex: "#D9C7A7" },
      { name: "Charcoal", hex: "#33383B" },
    ],
    images: [IMG.bath_b, IMG.towel_a, IMG.bath_a],
    rating: 4.7,
    reviewCount: 51,
  },
  {
    slug: "hotel-contract-bedding-set",
    title: "Hotel Contract Bedding Set",
    tag: "Contract",
    category: "hotel-bedding",
    price: 8999,
    mrp: 11500,
    caption: "5-star grade · Bulk MOQ",
    description:
      "Star-rated hospitality set: 300 TC percale sheet set + duvet cover + shams. Withstands industrial laundering. MOQ 50 sets.",
    material: "300 TC Percale, 100% Cotton",
    care: "Industrial laundering safe",
    sizes: ["Twin", "Double", "Queen", "King"],
    colours: [
      { name: "Snow", hex: "#F7F5EE" },
      { name: "Ivory", hex: "#EEE7DA" },
    ],
    images: [IMG.linen, IMG.bedroom_d, IMG.duvet_b],
    rating: 4.9,
    reviewCount: 33,
    featured: true,
  },
  {
    slug: "hotel-white-duvet-cover",
    title: "Hotel White Duvet Cover",
    category: "hotel-bedding",
    price: 3899,
    mrp: 4800,
    caption: "Percale · Cornerstone hotel white",
    description:
      "The white every hotel keeps returning to — a bright, honest percale with concealed closures.",
    material: "300 TC Percale Cotton",
    care: "Industrial laundering safe",
    sizes: ["Twin", "Double", "Queen", "King"],
    colours: [{ name: "Snow", hex: "#F7F5EE" }],
    images: [IMG.linen, IMG.duvet_a, IMG.bedroom_a],
    rating: 4.7,
    reviewCount: 22,
  },
  {
    slug: "mattress-protector-waterproof",
    title: "Waterproof Mattress Protector",
    category: "sheet-sets",
    price: 1899,
    mrp: 2400,
    caption: "Terry-top · Deep pocket",
    description:
      "Silent, breathable, and reliably waterproof. Fits mattresses up to 18\" deep.",
    material: "Cotton terry · TPU membrane",
    care: "Machine wash cold",
    sizes: ["Single", "Double", "Queen", "King"],
    colours: [{ name: "Snow", hex: "#F7F5EE" }],
    images: [IMG.duvet_a, IMG.linen, IMG.bedroom_b],
    rating: 4.6,
    reviewCount: 118,
  },
  {
    slug: "sofa-cover-stretch",
    title: "Stretch-fit Sofa Cover",
    category: "accents",
    price: 2499,
    mrp: 3400,
    caption: "3-seater · Stain-guard",
    description:
      "A tailored slipcover that hugs your sofa's frame — with a stain-repellent finish.",
    material: "Polyester-Spandex blend",
    care: "Machine wash cold",
    sizes: ["2-seater", "3-seater", "4-seater", "L-shape"],
    colours: [
      { name: "Bone", hex: "#EEE7DA" },
      { name: "Charcoal", hex: "#33383B" },
      { name: "Forest", hex: "#1E4F35" },
    ],
    images: [IMG.living_b, IMG.living_a, IMG.bedroom_e],
    rating: 4.5,
    reviewCount: 74,
  },
  {
    slug: "cotton-table-runner",
    title: "Cotton Table Runner",
    category: "accents",
    price: 899,
    mrp: 1200,
    caption: "72\" long · Woven",
    description:
      "Everyday-elegant table runner with a subtle woven texture and tassel finish.",
    material: "100% Cotton",
    care: "Machine wash cold",
    sizes: ["14×72", "14×90", "14×108"],
    colours: [
      { name: "Bone", hex: "#EEE7DA" },
      { name: "Forest", hex: "#1E4F35" },
      { name: "Ochre", hex: "#C79B4A" },
    ],
    images: [IMG.runner_a, IMG.bedroom_e, IMG.cushions],
    rating: 4.7,
    reviewCount: 41,
  },
  {
    slug: "round-duvet-cover",
    title: "Round Duvet Cover",
    tag: "Round",
    category: "duvet-covers",
    price: 5299,
    mrp: 6800,
    caption: "Made for round beds · 400 TC",
    description:
      "Precisely tailored for round mattresses. 400 TC sateen with a concealed zip.",
    material: "100% Cotton, 400 TC Sateen",
    care: "Machine wash cold",
    sizes: ["76\" round", "84\" round"],
    colours: [
      { name: "Ivoire", hex: "#EEE7DA" },
      { name: "Sand", hex: "#D9C7A7" },
    ],
    images: [IMG.round, IMG.bedroom_c, IMG.bedding_main],
    rating: 4.9,
    reviewCount: 36,
    featured: true,
  },
  {
    slug: "round-sheet-set",
    title: "Round Sheet Set",
    category: "sheet-sets",
    price: 4199,
    mrp: 5400,
    caption: "Made for round beds · Solid",
    description:
      "Fitted, flat and pillowcases — sized for round beds, with elasticated corners.",
    material: "400 TC Cotton Sateen",
    care: "Machine wash cold",
    sizes: ["76\" round", "84\" round"],
    colours: [
      { name: "Bone", hex: "#EEE7DA" },
      { name: "Sage", hex: "#B9C4AC" },
    ],
    images: [IMG.round, IMG.bedroom_b, IMG.bedding_main],
    rating: 4.7,
    reviewCount: 24,
  },
  {
    slug: "round-comforter",
    title: "Round Comforter",
    category: "comforters",
    price: 5999,
    mrp: 7500,
    caption: "Baffle-box · Round",
    description:
      "Fluffy, warm comforter designed for round beds. Even loft across the diameter.",
    material: "Cotton shell + microfibre fill",
    care: "Professional cleaning",
    sizes: ["76\" round", "84\" round"],
    colours: [{ name: "Snow", hex: "#F7F5EE" }],
    images: [IMG.round, IMG.duvet_a, IMG.bedroom_a],
    rating: 4.8,
    reviewCount: 19,
  },
  {
    slug: "round-mattress-protector",
    title: "Round Mattress Protector",
    category: "sheet-sets",
    price: 2299,
    mrp: 2900,
    caption: "Terry-top · Round · Waterproof",
    description:
      "A precisely-fit round protector — quiet, cool, and reliably waterproof.",
    material: "Cotton terry · TPU membrane",
    care: "Machine wash cold",
    sizes: ["76\" round", "84\" round"],
    colours: [{ name: "Snow", hex: "#F7F5EE" }],
    images: [IMG.round, IMG.linen, IMG.duvet_a],
    rating: 4.6,
    reviewCount: 14,
  },
  {
    slug: "custom-bench-cushion",
    title: "Custom Bench Cushion",
    tag: "Custom",
    category: "accents",
    price: 4499,
    mrp: 5900,
    caption: "Water-resistant · Made to measure",
    description:
      "Made-to-measure indoor bench cushion in your fabric and dimensions. 4\" high-density foam.",
    material: "High-density foam · Water-resistant cover",
    care: "Spot clean",
    sizes: ["Custom"],
    colours: [
      { name: "Bone", hex: "#EEE7DA" },
      { name: "Charcoal", hex: "#33383B" },
      { name: "Forest", hex: "#1E4F35" },
    ],
    images: [IMG.bench, IMG.bedroom_e, IMG.living_a],
    rating: 4.9,
    reviewCount: 47,
    featured: true,
  },
  {
    slug: "round-designer-bolster",
    title: "Round Designer Bolster",
    category: "accents",
    price: 1799,
    mrp: 2400,
    caption: "8\"×24\" · Muslin tassels",
    description:
      "A gently rounded bolster in soft muslin with tonal tassel ends.",
    material: "Cotton muslin cover · Polyfill insert",
    care: "Cover: hand wash cold",
    sizes: ["8×24"],
    colours: [
      { name: "Bone", hex: "#EEE7DA" },
      { name: "Sand", hex: "#D9C7A7" },
    ],
    images: [IMG.bolster, IMG.cushions, IMG.bedroom_e],
    rating: 4.7,
    reviewCount: 32,
  },
  {
    slug: "throw-blanket-mink",
    title: "Mink Throw Blanket",
    category: "quilts-bedspreads",
    price: 2299,
    mrp: 2900,
    caption: "Ultra-soft · 200×220 cm",
    description:
      "A cloud-soft mink throw — dense pile, generous sizing. Perfect for the sofa or foot of bed.",
    material: "Polyester Mink",
    care: "Machine wash cold",
    sizes: ["150×200", "200×220"],
    colours: [
      { name: "Bone", hex: "#EEE7DA" },
      { name: "Charcoal", hex: "#33383B" },
      { name: "Forest", hex: "#1E4F35" },
    ],
    images: [IMG.bedspread, IMG.bedroom_c, IMG.cushions],
    rating: 4.8,
    reviewCount: 88,
  },
  {
    slug: "linen-table-napkin-set",
    title: "Linen Napkin Set (Set of 6)",
    category: "kitchen-dining",
    price: 1499,
    mrp: 1900,
    caption: "Stonewashed linen · Mitred hem",
    description:
      "Six softly rumpled linen napkins — for long lunches and slow dinners.",
    material: "100% Linen",
    care: "Machine wash cold",
    sizes: ["18×18"],
    colours: [
      { name: "Bone", hex: "#EEE7DA" },
      { name: "Forest", hex: "#1E4F35" },
      { name: "Sand", hex: "#D9C7A7" },
    ],
    images: [IMG.runner_a, IMG.bedroom_e, IMG.cushions],
    rating: 4.7,
    reviewCount: 26,
  },
  // ------ Kitchen & Dining ------
  {
    slug: "cotton-chef-apron",
    title: "Cotton Chef Apron",
    tag: "New",
    category: "kitchen-dining",
    price: 1299,
    mrp: 1700,
    caption: "Heavyweight · Adjustable strap",
    description: "A workhorse apron in heavyweight cotton with reinforced pockets and a solid brass buckle.",
    material: "100% Cotton, 240 GSM",
    care: "Machine wash warm",
    sizes: ["One size"],
    colours: [
      { name: "Bone", hex: "#EEE7DA" },
      { name: "Forest", hex: "#1E4F35" },
      { name: "Charcoal", hex: "#33383B" },
    ],
    images: [IMG.runner_a, IMG.cushions, IMG.bedroom_e],
    rating: 4.7, reviewCount: 34, featured: true,
  },
  {
    slug: "waffle-kitchen-towel-set",
    title: "Waffle Kitchen Towel Set (Set of 4)",
    category: "kitchen-dining",
    price: 1099, mrp: 1500,
    caption: "Absorbent · Quick-drying",
    description: "Waffle-weave kitchen towels that dry glasses without lint and hang neatly from a rail.",
    material: "100% Cotton, 500 GSM",
    care: "Machine wash warm",
    sizes: ["Set of 4"],
    colours: [{ name: "Bone", hex: "#EEE7DA" }, { name: "Sage", hex: "#B9C4AC" }],
    images: [IMG.bath_b, IMG.towel_a, IMG.runner_a],
    rating: 4.8, reviewCount: 58,
  },
  {
    slug: "woven-placemat-set",
    title: "Woven Placemat Set (Set of 6)",
    category: "kitchen-dining",
    price: 1499, mrp: 1900,
    caption: "Handwoven · Fringed",
    description: "Softly handwoven placemats with subtly frayed edges — ready for every-day suppers and weekend tables.",
    material: "Cotton blend",
    care: "Machine wash cold",
    sizes: ["Set of 6"],
    colours: [{ name: "Bone", hex: "#EEE7DA" }, { name: "Sand", hex: "#D9C7A7" }, { name: "Forest", hex: "#1E4F35" }],
    images: [IMG.runner_a, IMG.cushions, IMG.bedroom_e],
    rating: 4.6, reviewCount: 41,
  },
  {
    slug: "linen-tea-towel-pair",
    title: "Linen Tea Towel Pair",
    category: "kitchen-dining",
    price: 899, mrp: 1200,
    caption: "Fast-drying · Lint-free",
    description: "Fine linen tea towels — great for glassware and produce.",
    material: "100% Linen",
    care: "Machine wash cold",
    sizes: ["Set of 2"],
    colours: [{ name: "Bone", hex: "#EEE7DA" }, { name: "Charcoal", hex: "#33383B" }],
    images: [IMG.runner_a, IMG.bath_b, IMG.cushions],
    rating: 4.7, reviewCount: 22,
  },
  {
    slug: "coaster-set-cork",
    title: "Cork-Backed Coasters (Set of 6)",
    category: "kitchen-dining",
    price: 599, mrp: 800,
    caption: "Cork base · Heat-safe",
    description: "Six printed coasters with cork bases — grippy on the table, gentle on the glass.",
    material: "Cotton + Cork",
    care: "Wipe clean",
    sizes: ["Set of 6"],
    colours: [{ name: "Bone", hex: "#EEE7DA" }],
    images: [IMG.cushions, IMG.runner_a, IMG.bedroom_e],
    rating: 4.5, reviewCount: 18,
  },
  // ------ Throws & Blankets ------
  {
    slug: "cashmere-blend-throw",
    title: "Cashmere-Blend Throw",
    tag: "Bestseller",
    category: "throws-blankets",
    price: 5999, mrp: 8500,
    caption: "70% wool · 30% cashmere",
    description: "A weightless, warm throw in a wool-cashmere blend — the last layer at the foot of the bed.",
    material: "70% Wool, 30% Cashmere",
    care: "Dry clean only",
    sizes: ["130×200"],
    colours: [{ name: "Bone", hex: "#EEE7DA" }, { name: "Forest", hex: "#1E4F35" }, { name: "Charcoal", hex: "#33383B" }],
    images: [IMG.bedspread, IMG.bedroom_c, IMG.cushions],
    rating: 4.9, reviewCount: 71, featured: true,
  },
  {
    slug: "waffle-cotton-throw",
    title: "Waffle Cotton Throw",
    category: "throws-blankets",
    price: 2499, mrp: 3200,
    caption: "Breathable · Everyday drape",
    description: "A textured waffle-weave throw that breathes in summer and warms in winter.",
    material: "100% Cotton",
    care: "Machine wash cold",
    sizes: ["130×200"],
    colours: [{ name: "Bone", hex: "#EEE7DA" }, { name: "Sage", hex: "#B9C4AC" }],
    images: [IMG.bedspread, IMG.duvet_b, IMG.bedroom_c],
    rating: 4.7, reviewCount: 44,
  },
  {
    slug: "faux-fur-throw",
    title: "Faux-Fur Throw",
    category: "throws-blankets",
    price: 3299, mrp: 4200,
    caption: "Long pile · Silky reverse",
    description: "Deep, indulgent faux-fur on one side and a silky knit reverse. Sofa-friendly.",
    material: "Acrylic pile · Polyester reverse",
    care: "Machine wash cold",
    sizes: ["150×200"],
    colours: [{ name: "Ivoire", hex: "#EEE7DA" }, { name: "Sand", hex: "#D9C7A7" }],
    images: [IMG.bedspread, IMG.bedroom_c, IMG.duvet_a],
    rating: 4.6, reviewCount: 37,
  },
  {
    slug: "weighted-blanket-7kg",
    title: "Weighted Blanket · 7kg",
    tag: "Wellness",
    category: "throws-blankets",
    price: 4499, mrp: 5900,
    caption: "Glass-bead fill · Cotton shell",
    description: "Even, evenly-distributed pressure for calm nights. Machine-washable cotton cover.",
    material: "Cotton shell + glass-bead fill",
    care: "Cover machine wash cold",
    sizes: ["135×200 · 7kg", "150×220 · 9kg"],
    colours: [{ name: "Charcoal", hex: "#33383B" }, { name: "Bone", hex: "#EEE7DA" }],
    images: [IMG.bedroom_a, IMG.duvet_a, IMG.bedspread],
    rating: 4.8, reviewCount: 92,
  },
  // ------ Rugs & Mats ------
  {
    slug: "cotton-dhurrie-rug",
    title: "Cotton Dhurrie Rug",
    tag: "Handloom",
    category: "rugs-mats",
    price: 3999, mrp: 5200,
    caption: "Flat-weave · Handloom",
    description: "A flat-weave dhurrie in soft, natural tones — light enough to lift, sturdy enough for daily use.",
    material: "100% Cotton",
    care: "Vacuum · Spot clean",
    sizes: ["3×5 ft", "5×7 ft", "6×9 ft"],
    colours: [{ name: "Bone / Forest", hex: "#1E4F35" }, { name: "Bone / Charcoal", hex: "#33383B" }],
    images: [IMG.living_a, IMG.bedroom_e, IMG.cushions],
    rating: 4.8, reviewCount: 43, featured: true,
  },
  {
    slug: "chenille-bath-mat",
    title: "Chenille Bath Mat",
    category: "rugs-mats",
    price: 999, mrp: 1400,
    caption: "Plush chenille · Anti-slip",
    description: "Soft chenille mat with a non-slip backing — warm underfoot after a shower.",
    material: "Chenille + TPR backing",
    care: "Machine wash cold",
    sizes: ["50×80"],
    colours: [{ name: "Bone", hex: "#EEE7DA" }, { name: "Sage", hex: "#B9C4AC" }, { name: "Charcoal", hex: "#33383B" }],
    images: [IMG.bath_a, IMG.bath_b, IMG.towel_a],
    rating: 4.7, reviewCount: 61,
  },
  {
    slug: "hallway-cotton-runner",
    title: "Hallway Cotton Runner",
    category: "rugs-mats",
    price: 2999, mrp: 3900,
    caption: "Long · Machine washable",
    description: "A long, easy-to-wash runner for kitchens and hallways.",
    material: "100% Cotton",
    care: "Machine wash cold",
    sizes: ["2.5×6 ft", "2.5×8 ft"],
    colours: [{ name: "Bone", hex: "#EEE7DA" }, { name: "Sand", hex: "#D9C7A7" }],
    images: [IMG.living_a, IMG.bedroom_c, IMG.living_b],
    rating: 4.6, reviewCount: 24,
  },
  {
    slug: "tufted-bedside-rug",
    title: "Tufted Bedside Rug",
    category: "rugs-mats",
    price: 1999, mrp: 2600,
    caption: "Cut-pile · Softwash cotton",
    description: "A tufted bedside rug that softens the first step of the morning.",
    material: "Cotton pile",
    care: "Vacuum · Spot clean",
    sizes: ["60×90", "70×140"],
    colours: [{ name: "Ivoire", hex: "#EEE7DA" }, { name: "Sand", hex: "#D9C7A7" }],
    images: [IMG.bedroom_c, IMG.bedspread, IMG.bedroom_a],
    rating: 4.7, reviewCount: 33,
  },
  // ------ Baby & Kids ------
  {
    slug: "baby-muslin-blanket",
    title: "Baby Muslin Blanket",
    tag: "Kids",
    category: "baby-kids",
    price: 1199, mrp: 1600,
    caption: "6-layer · Breathable",
    description: "Six layers of soft, breathable muslin — for naps, prams and swaddling.",
    material: "100% Cotton Muslin",
    care: "Machine wash warm",
    sizes: ["90×90", "110×110"],
    colours: [{ name: "Bone", hex: "#EEE7DA" }, { name: "Sage", hex: "#B9C4AC" }, { name: "Rose", hex: "#D6B5B0" }],
    images: [IMG.bedroom_c, IMG.duvet_a, IMG.bath_a],
    rating: 4.9, reviewCount: 128, featured: true,
  },
  {
    slug: "crib-sheet-set",
    title: "Crib Sheet Set (Set of 2)",
    category: "baby-kids",
    price: 1599, mrp: 2100,
    caption: "300 TC · GOTS Cotton",
    description: "Two fitted crib sheets in soft, safe cotton — snug elastic and reinforced corners.",
    material: "300 TC GOTS Cotton",
    care: "Machine wash warm",
    sizes: ["Standard Crib"],
    colours: [{ name: "Snow", hex: "#F7F5EE" }, { name: "Rose", hex: "#D6B5B0" }, { name: "Sage", hex: "#B9C4AC" }],
    images: [IMG.bedding_main, IMG.duvet_b, IMG.bedroom_b],
    rating: 4.8, reviewCount: 74,
  },
  {
    slug: "hooded-baby-towel",
    title: "Hooded Baby Towel",
    category: "baby-kids",
    price: 1099, mrp: 1500,
    caption: "600 GSM · Ear-hood",
    description: "A cloud-soft hooded towel for bath-time wraps.",
    material: "100% Cotton, 600 GSM",
    care: "Machine wash warm",
    sizes: ["80×80"],
    colours: [{ name: "Bone", hex: "#EEE7DA" }, { name: "Sage", hex: "#B9C4AC" }],
    images: [IMG.bath_a, IMG.towel_a, IMG.bath_b],
    rating: 4.9, reviewCount: 88,
  },
  {
    slug: "kids-cotton-robe",
    title: "Kids Cotton Robe",
    category: "baby-kids",
    price: 1499, mrp: 1900,
    caption: "Ages 2-8 · Waffle weave",
    description: "A lightweight waffle robe for little bath-time regulars.",
    material: "100% Cotton",
    care: "Machine wash warm",
    sizes: ["2-4y", "4-6y", "6-8y"],
    colours: [{ name: "Bone", hex: "#EEE7DA" }, { name: "Sage", hex: "#B9C4AC" }],
    images: [IMG.bath_a, IMG.bath_b, IMG.towel_a],
    rating: 4.7, reviewCount: 36,
  },
  {
    slug: "nursery-blackout-curtains",
    title: "Nursery Blackout Curtains",
    category: "baby-kids",
    price: 3299, mrp: 4300,
    caption: "Nap-time approved · Thermal",
    description: "Soft, muted colours in a room-darkening weave — for daytime naps and calm mornings.",
    material: "Cotton-blend + blackout lining",
    care: "Dry clean recommended",
    sizes: ["54×72", "54×84", "Custom"],
    colours: [{ name: "Sand", hex: "#D9C7A7" }, { name: "Sage", hex: "#B9C4AC" }, { name: "Rose", hex: "#D6B5B0" }],
    images: [IMG.curtains, IMG.bedroom_c, IMG.bedroom_d],
    rating: 4.8, reviewCount: 42,
  },
  // ------ Bath expansion ------
  {
    slug: "waffle-kimono-robe",
    title: "Waffle Kimono Robe",
    tag: "Robes",
    category: "bath",
    price: 3299, mrp: 4200,
    caption: "Kimono shape · Waffle weave",
    description: "A gender-neutral kimono in soft waffle-weave cotton — spa-elegant.",
    material: "100% Cotton",
    care: "Machine wash warm",
    sizes: ["S", "M", "L", "XL"],
    colours: [{ name: "Bone", hex: "#EEE7DA" }, { name: "Sage", hex: "#B9C4AC" }, { name: "Charcoal", hex: "#33383B" }],
    images: [IMG.bath_a, IMG.bath_b, IMG.towel_a],
    rating: 4.8, reviewCount: 58,
  },
  {
    slug: "hand-towel-pair",
    title: "Hand Towel Pair",
    category: "bath",
    price: 699, mrp: 900,
    caption: "600 GSM · Piped edges",
    description: "Two dense hand towels for the everyday wash-basin.",
    material: "100% Cotton, 600 GSM",
    care: "Machine wash warm",
    sizes: ["Set of 2"],
    colours: [{ name: "Bone", hex: "#EEE7DA" }, { name: "Sage", hex: "#B9C4AC" }, { name: "Charcoal", hex: "#33383B" }],
    images: [IMG.towel_a, IMG.bath_a, IMG.bath_b],
    rating: 4.7, reviewCount: 34,
  },
  {
    slug: "face-towel-set",
    title: "Face Towel Set (Set of 6)",
    category: "bath",
    price: 899, mrp: 1200,
    caption: "500 GSM · Muslin-soft",
    description: "Six face towels in a gently textured cotton — great for skin-care routines.",
    material: "100% Cotton",
    care: "Machine wash warm",
    sizes: ["Set of 6"],
    colours: [{ name: "Bone", hex: "#EEE7DA" }, { name: "Rose", hex: "#D6B5B0" }],
    images: [IMG.towel_a, IMG.bath_a, IMG.bath_b],
    rating: 4.6, reviewCount: 21,
  },
  // ------ More Cushion Covers ------
  {
    slug: "silk-blend-cushion",
    title: "Silk-Blend Cushion Cover",
    category: "pillow-covers",
    price: 1899, mrp: 2500,
    caption: "18\"×18\" · Lustrous silk-blend",
    description: "A quiet-luxe cushion in a lustrous silk blend — instant drama on a bed or sofa.",
    material: "Silk blend",
    care: "Cold hand wash",
    sizes: ["18×18", "20×20"],
    colours: [{ name: "Ivoire", hex: "#EEE7DA" }, { name: "Ochre", hex: "#C79B4A" }, { name: "Forest", hex: "#1E4F35" }],
    images: [IMG.cushions, IMG.cushion_b, IMG.cushion_c],
    rating: 4.7, reviewCount: 32,
  },
  {
    slug: "embroidered-boho-cushion",
    title: "Embroidered Boho Cushion",
    tag: "Handmade",
    category: "pillow-covers",
    price: 1599, mrp: 2100,
    caption: "20\"×20\" · Chain-stitched",
    description: "A hand-embroidered cushion with chain-stitched motifs — thoughtful, textural, slow.",
    material: "Cotton",
    care: "Cold hand wash",
    sizes: ["20×20"],
    colours: [{ name: "Bone", hex: "#EEE7DA" }, { name: "Sand", hex: "#D9C7A7" }],
    images: [IMG.cushion_c, IMG.cushions, IMG.cushion_b],
    rating: 4.9, reviewCount: 46,
  },
  {
    slug: "chunky-knit-cushion",
    title: "Chunky-Knit Cushion",
    category: "pillow-covers",
    price: 1399, mrp: 1800,
    caption: "18\"×18\" · Textural knit",
    description: "A cable-knit cushion in a warm, oatmeal colourway.",
    material: "Cotton knit",
    care: "Cold hand wash",
    sizes: ["18×18"],
    colours: [{ name: "Oatmeal", hex: "#D9C7A7" }, { name: "Charcoal", hex: "#33383B" }],
    images: [IMG.cushion_b, IMG.cushions, IMG.cushion_c],
    rating: 4.6, reviewCount: 27,
  },
  // ------ Accents expansion ------
  {
    slug: "cotton-wall-tapestry",
    title: "Cotton Wall Tapestry",
    category: "accents",
    price: 2499, mrp: 3200,
    caption: "36\"×48\" · Hand-loomed",
    description: "A quiet piece of textile art — soft palette, subtle pattern, made to hang.",
    material: "100% Cotton",
    care: "Vacuum · Spot clean",
    sizes: ["36×48"],
    colours: [{ name: "Bone", hex: "#EEE7DA" }, { name: "Sand", hex: "#D9C7A7" }],
    images: [IMG.craft, IMG.bedroom_e, IMG.cushions],
    rating: 4.7, reviewCount: 19,
  },
  {
    slug: "cane-storage-basket",
    title: "Cane Storage Basket",
    category: "accents",
    price: 1799, mrp: 2400,
    caption: "Handwoven · Large",
    description: "A generously-sized cane basket for throws, toys or laundry.",
    material: "Cane",
    care: "Dry-dust only",
    sizes: ["Medium", "Large"],
    colours: [{ name: "Natural", hex: "#D9C7A7" }],
    images: [IMG.bedroom_e, IMG.living_b, IMG.living_a],
    rating: 4.5, reviewCount: 16,
  },
  {
    slug: "scented-linen-sachets",
    title: "Scented Linen Sachets (Set of 3)",
    category: "accents",
    price: 799, mrp: 1000,
    caption: "Cedar · Lavender · Vetiver",
    description: "Three linen sachets for wardrobes and drawers.",
    material: "Linen + botanical fill",
    care: "Squeeze to refresh",
    sizes: ["Set of 3"],
    colours: [{ name: "Bone", hex: "#EEE7DA" }],
    images: [IMG.cushions, IMG.runner_a, IMG.bedroom_e],
    rating: 4.6, reviewCount: 22,
  },
  {
    slug: "decorative-jute-tray",
    title: "Decorative Jute Tray",
    category: "accents",
    price: 1299, mrp: 1700,
    caption: "Round · Rope-handles",
    description: "A round jute tray for slow mornings — coffee, croissant, book.",
    material: "Jute + wooden base",
    care: "Wipe clean",
    sizes: ["18\" round"],
    colours: [{ name: "Natural", hex: "#D9C7A7" }],
    images: [IMG.bedroom_e, IMG.runner_a, IMG.living_a],
    rating: 4.7, reviewCount: 14,
  },
  // ------ Monogram Bedding ------
  {
    slug: "monogram-sheet-set",
    title: "Monogram Sheet Set", tag: "Custom", category: "monogram-bedding",
    price: 5499, mrp: 7200, caption: "400 TC · Chain-stitched initials",
    description: "Personalised sateen sheet set with your monogram embroidered on the flat sheet corner.",
    material: "400 TC Cotton Sateen", care: "Machine wash cold",
    sizes: ["Single", "Double", "Queen", "King"],
    colours: [{ name: "Ivoire", hex: "#EEE7DA" }, { name: "Sand", hex: "#D9C7A7" }],
    images: [IMG.bedding_main, IMG.duvet_a, IMG.bedroom_a],
    rating: 4.9, reviewCount: 62, featured: true,
  },
  {
    slug: "monogram-pillow-shams",
    title: "Monogram Pillow Shams (Pair)", category: "monogram-bedding",
    price: 2299, mrp: 2900, caption: "Piped edges · Custom initials",
    description: "Two chain-stitched monogram shams to finish the bed.",
    material: "400 TC Sateen", care: "Machine wash cold",
    sizes: ["Standard", "King"],
    colours: [{ name: "Ivoire", hex: "#EEE7DA" }, { name: "Forest", hex: "#1E4F35" }],
    images: [IMG.cushions, IMG.duvet_b, IMG.bedroom_a],
    rating: 4.8, reviewCount: 41,
  },
  // ------ Headboards ------
  {
    slug: "linen-upholstered-headboard",
    title: "Linen Upholstered Headboard", tag: "New", category: "headboards",
    price: 12999, mrp: 16500, caption: "Wall-mounted · Foam-padded",
    description: "A generously padded linen headboard — sits behind the bed on a discrete cleat.",
    material: "Linen upholstery · Ply core · Foam pad",
    care: "Vacuum · Spot clean",
    sizes: ["Queen", "King"],
    colours: [{ name: "Bone", hex: "#EEE7DA" }, { name: "Sand", hex: "#D9C7A7" }, { name: "Charcoal", hex: "#33383B" }],
    images: [IMG.bedroom_e, IMG.bedroom_a, IMG.duvet_a],
    rating: 4.8, reviewCount: 22, featured: true,
  },
  {
    slug: "velvet-tufted-headboard",
    title: "Velvet Tufted Headboard", category: "headboards",
    price: 14999, mrp: 18500, caption: "Deep buttons · Wing-back",
    description: "A wing-back velvet headboard with deep button tufting — quiet drama.",
    material: "Velvet upholstery",
    care: "Vacuum · Spot clean",
    sizes: ["Queen", "King"],
    colours: [{ name: "Forest", hex: "#1E4F35" }, { name: "Wine", hex: "#5B1A2A" }, { name: "Charcoal", hex: "#33383B" }],
    images: [IMG.cushions, IMG.bedroom_e, IMG.bedroom_a],
    rating: 4.9, reviewCount: 18,
  },
  // ------ Cushion Covers (separate cat) ------
  {
    slug: "linen-lumbar-cushion",
    title: "Linen Lumbar Cushion", category: "cushion-covers",
    price: 1499, mrp: 1900, caption: "14×22 · Long lumbar",
    description: "A long lumbar cushion in stonewashed linen — the last layer at the head of the bed.",
    material: "Linen · Cotton back", care: "Cold hand wash",
    sizes: ["14×22"],
    colours: [{ name: "Bone", hex: "#EEE7DA" }, { name: "Sand", hex: "#D9C7A7" }],
    images: [IMG.cushion_b, IMG.cushions, IMG.cushion_c],
    rating: 4.7, reviewCount: 34,
  },
  {
    slug: "square-linen-cushion",
    title: "Square Linen Cushion Cover", category: "cushion-covers",
    price: 999, mrp: 1300, caption: "20×20 · Slouch fit",
    description: "A slouchy 20×20 cushion cover in soft linen.",
    material: "Linen", care: "Machine wash cold",
    sizes: ["20×20"],
    colours: [{ name: "Bone", hex: "#EEE7DA" }, { name: "Sage", hex: "#B9C4AC" }],
    images: [IMG.cushion_c, IMG.cushions, IMG.cushion_b],
    rating: 4.6, reviewCount: 27,
  },
  // ------ Custom Bedding ------
  {
    slug: "custom-duvet-any-size",
    title: "Custom Duvet Cover · Any Size", tag: "Made-to-order", category: "custom-bedding",
    price: 6999, mrp: 8900, caption: "Your size · Your fabric",
    description: "Bring us your measurements and fabric preference — we&rsquo;ll develop a made-to-measure duvet.",
    material: "Cotton / Linen / Sateen · Your choice", care: "Per material",
    sizes: ["Custom"],
    colours: [{ name: "Your choice", hex: "#EEE7DA" }],
    images: [IMG.duvet_a, IMG.bedroom_a, IMG.bedding_main],
    rating: 4.9, reviewCount: 38, featured: true,
  },
  {
    slug: "custom-comforter-any-fill",
    title: "Custom Comforter", category: "custom-bedding",
    price: 7499, mrp: 9500, caption: "Choose loft, fill, size",
    description: "Custom-filled comforter to your loft and warmth preference.",
    material: "Cotton shell + fill of choice", care: "Professional cleaning",
    sizes: ["Custom"],
    colours: [{ name: "Ivoire", hex: "#EEE7DA" }],
    images: [IMG.duvet_a, IMG.bedroom_a, IMG.linen],
    rating: 4.8, reviewCount: 21,
  },
  // ------ Sofa Covers (own cat) ------
  {
    slug: "sofa-slipcover-linen",
    title: "Linen Sofa Slipcover", category: "sofa-covers",
    price: 5999, mrp: 7600, caption: "Custom-fit · Washable",
    description: "A made-to-measure linen slipcover — soft rumpled fit, machine-washable.",
    material: "100% Linen", care: "Machine wash cold",
    sizes: ["2-seater", "3-seater", "4-seater", "L-shape"],
    colours: [{ name: "Bone", hex: "#EEE7DA" }, { name: "Sand", hex: "#D9C7A7" }],
    images: [IMG.living_a, IMG.living_b, IMG.bedroom_e],
    rating: 4.8, reviewCount: 33, featured: true,
  },
  {
    slug: "sofa-slipcover-velvet",
    title: "Velvet Sofa Slipcover", category: "sofa-covers",
    price: 6999, mrp: 8500, caption: "Custom-fit · Rich pile",
    description: "A velvet slipcover with a rich, quiet pile.",
    material: "Cotton velvet", care: "Dry clean recommended",
    sizes: ["3-seater", "L-shape"],
    colours: [{ name: "Forest", hex: "#1E4F35" }, { name: "Charcoal", hex: "#33383B" }],
    images: [IMG.living_b, IMG.living_a, IMG.cushion_b],
    rating: 4.7, reviewCount: 19,
  },
  // ------ Bedskirts ------
  {
    slug: "linen-bedskirt-tailored",
    title: "Tailored Linen Bedskirt", category: "bedskirts",
    price: 2499, mrp: 3200, caption: "Split corners · 16\" drop",
    description: "A tailored bedskirt in stonewashed linen with a clean 16&Prime; drop.",
    material: "Linen skirt · Cotton deck", care: "Machine wash cold",
    sizes: ["Queen", "King"],
    colours: [{ name: "Bone", hex: "#EEE7DA" }, { name: "Sand", hex: "#D9C7A7" }],
    images: [IMG.bedroom_c, IMG.bedroom_a, IMG.duvet_a],
    rating: 4.7, reviewCount: 28,
  },
  {
    slug: "ruffle-bedskirt-cotton",
    title: "Ruffle Bedskirt · Cotton", category: "bedskirts",
    price: 1999, mrp: 2600, caption: "Gathered ruffle · 18\" drop",
    description: "A soft, gathered ruffle bedskirt for a lightly romantic bed.",
    material: "100% Cotton", care: "Machine wash cold",
    sizes: ["Queen", "King"],
    colours: [{ name: "Bone", hex: "#EEE7DA" }, { name: "Rose", hex: "#D6B5B0" }],
    images: [IMG.bedroom_c, IMG.bedspread, IMG.bedroom_a],
    rating: 4.6, reviewCount: 17,
  },
  // ------ Handmade Bags ------
  {
    slug: "handloom-tote-bag",
    title: "Handloom Tote Bag", tag: "Handmade", category: "handmade-bags",
    price: 1799, mrp: 2400, caption: "Cotton canvas · Leather straps",
    description: "A generously-sized handloom tote with vegetable-tanned leather straps.",
    material: "Cotton canvas · Leather", care: "Spot clean",
    sizes: ["Medium", "Large"],
    colours: [{ name: "Natural", hex: "#D9C7A7" }, { name: "Charcoal", hex: "#33383B" }],
    images: [IMG.craft, IMG.bedroom_e, IMG.cushions],
    rating: 4.8, reviewCount: 46, featured: true,
  },
  {
    slug: "embroidered-clutch",
    title: "Embroidered Clutch", category: "handmade-bags",
    price: 1499, mrp: 1900, caption: "Chain-stitched · Silk lining",
    description: "A chain-stitched clutch on natural cotton with silk lining.",
    material: "Cotton · Silk lining", care: "Spot clean",
    sizes: ["One size"],
    colours: [{ name: "Ivoire", hex: "#EEE7DA" }, { name: "Ochre", hex: "#C79B4A" }],
    images: [IMG.cushion_c, IMG.craft, IMG.cushions],
    rating: 4.7, reviewCount: 22,
  },
  // ------ Handmade Gifts ------
  {
    slug: "handmade-gift-hamper-small",
    title: "Handmade Gift Hamper · Small", tag: "Gifting", category: "handmade-gifts",
    price: 2499, mrp: 3200, caption: "Napkins · Coasters · Sachet",
    description: "A small hamper of handmade linen napkins, cork coasters, and a scented sachet — beautifully wrapped.",
    material: "Linen · Cotton · Cork", care: "Per item",
    sizes: ["Small hamper"],
    colours: [{ name: "Bone", hex: "#EEE7DA" }],
    images: [IMG.cushion_c, IMG.runner_a, IMG.craft],
    rating: 4.9, reviewCount: 54, featured: true,
  },
  {
    slug: "handmade-gift-hamper-large",
    title: "Handmade Gift Hamper · Large", category: "handmade-gifts",
    price: 4499, mrp: 5900, caption: "Robe · Towel · Slippers",
    description: "A larger hamper with a waffle robe, hand towel, and cotton slippers.",
    material: "Cotton", care: "Machine wash warm",
    sizes: ["Large hamper"],
    colours: [{ name: "Bone", hex: "#EEE7DA" }, { name: "Sage", hex: "#B9C4AC" }],
    images: [IMG.bath_a, IMG.towel_a, IMG.bath_b],
    rating: 4.8, reviewCount: 31,
  },
  // ------ Personalised Gifts ------
  {
    slug: "personalised-robe",
    title: "Personalised Robe", tag: "Personalise", category: "personalised-gifts",
    price: 3499, mrp: 4400, caption: "Chain-stitched name",
    description: "A waffle robe with your name (or theirs) stitched on the chest.",
    material: "100% Cotton waffle", care: "Machine wash warm",
    sizes: ["S", "M", "L", "XL"],
    colours: [{ name: "Bone", hex: "#EEE7DA" }, { name: "Slate", hex: "#4C5B5C" }],
    images: [IMG.bath_a, IMG.towel_a, IMG.bath_b],
    rating: 4.9, reviewCount: 71,
  },
  {
    slug: "personalised-towel-set",
    title: "Personalised Towel Set", category: "personalised-gifts",
    price: 2999, mrp: 3900, caption: "Set of 3 · Custom initials",
    description: "Three plush towels with your initials embroidered — a lasting gift.",
    material: "600 GSM Cotton", care: "Machine wash warm",
    sizes: ["Set of 3"],
    colours: [{ name: "Bone", hex: "#EEE7DA" }, { name: "Sage", hex: "#B9C4AC" }],
    images: [IMG.towel_a, IMG.bath_a, IMG.bath_b],
    rating: 4.8, reviewCount: 44,
  },
  // ------ Custom Gifts ------
  {
    slug: "custom-gift-box-builder",
    title: "Build-Your-Own Gift Box", tag: "Custom", category: "custom-gifts",
    price: 1999, mrp: 2600, caption: "Choose 3–6 items",
    description: "Design a custom gift box — pick 3-6 items from towels, sachets, napkins, coasters, robes and more.",
    material: "Various", care: "Per item",
    sizes: ["3 items", "4 items", "6 items"],
    colours: [{ name: "Your choice", hex: "#EEE7DA" }],
    images: [IMG.cushion_c, IMG.craft, IMG.cushions],
    rating: 4.9, reviewCount: 62, featured: true,
  },
  {
    slug: "custom-wedding-gift",
    title: "Custom Wedding Gift Bundle", category: "custom-gifts",
    price: 6999, mrp: 8500, caption: "Newlywed essentials · Personalised",
    description: "A newlywed bundle — sheet set + duvet cover + two towels, personalised with initials.",
    material: "Cotton", care: "Machine wash cold",
    sizes: ["Queen", "King"],
    colours: [{ name: "Ivoire", hex: "#EEE7DA" }],
    images: [IMG.bedding_main, IMG.duvet_a, IMG.bath_a],
    rating: 4.9, reviewCount: 28,
  },
  // ------ Winter Jackets ------
  {
    slug: "quilted-cotton-jacket",
    title: "Quilted Cotton Jacket", tag: "Winter", category: "winter-jackets",
    price: 4999, mrp: 6500, caption: "Kantha-quilted · Reversible",
    description: "A hand-quilted cotton jacket that reverses — lightweight but warm.",
    material: "Cotton shell + cotton fill", care: "Cold hand wash",
    sizes: ["S", "M", "L", "XL"],
    colours: [{ name: "Bone", hex: "#EEE7DA" }, { name: "Forest", hex: "#1E4F35" }, { name: "Ochre", hex: "#C79B4A" }],
    images: [IMG.bedspread, IMG.bath_a, IMG.craft],
    rating: 4.8, reviewCount: 39, featured: true,
  },
  {
    slug: "wool-blend-cape",
    title: "Wool-Blend Cape", category: "winter-jackets",
    price: 5999, mrp: 7500, caption: "Wool · Ivory · Ivory",
    description: "A wool-blend cape for shoulder seasons.",
    material: "70% Wool, 30% Cotton", care: "Dry clean",
    sizes: ["One size"],
    colours: [{ name: "Ivoire", hex: "#EEE7DA" }, { name: "Charcoal", hex: "#33383B" }],
    images: [IMG.bedspread, IMG.craft, IMG.bedroom_c],
    rating: 4.7, reviewCount: 22,
  },
  // ------ Linen Dresses ------
  {
    slug: "linen-slip-dress",
    title: "Linen Slip Dress", tag: "New", category: "linen-dresses",
    price: 3499, mrp: 4400, caption: "Bias-cut · Midi length",
    description: "A weightless bias-cut linen slip — for warm evenings and quiet mornings.",
    material: "100% Linen", care: "Machine wash cold",
    sizes: ["XS", "S", "M", "L"],
    colours: [{ name: "Bone", hex: "#EEE7DA" }, { name: "Sand", hex: "#D9C7A7" }, { name: "Sage", hex: "#B9C4AC" }],
    images: [IMG.linen, IMG.bath_a, IMG.craft],
    rating: 4.8, reviewCount: 58, featured: true,
  },
  {
    slug: "linen-shirt-dress",
    title: "Linen Shirt Dress", category: "linen-dresses",
    price: 3999, mrp: 5100, caption: "Belted · Midi",
    description: "A belted linen shirt-dress with pockets and a soft, rumpled hand.",
    material: "100% Linen", care: "Machine wash cold",
    sizes: ["XS", "S", "M", "L", "XL"],
    colours: [{ name: "Bone", hex: "#EEE7DA" }, { name: "Sand", hex: "#D9C7A7" }, { name: "Charcoal", hex: "#33383B" }],
    images: [IMG.linen, IMG.craft, IMG.bath_a],
    rating: 4.7, reviewCount: 44,
  },
];

// Legacy list kept so nothing else breaks (aliased to PRODUCTS)
export const PRODUCTS_LIST = PRODUCTS;

export const MANIFESTO_CHAPTERS = [
  { number: "01", title: "A house of textile.", body: "Anabiya Decor is a Mumbai-born manufacturer of premium bedding and home furnishing — engineered in our mills, finished by hand, and shipped in bulk to homes, hotels and studios across India." },
  { number: "02", title: "Millwork, still felt by hand.", body: "We spin, weave, dye and stitch under one roof. Every metre of fabric passes through a quality gate — thread count, GSM, colour-fastness, shrink control — before it earns our label." },
  { number: "03", title: "Made for wholesale, priced direct.", body: "Because we own the factory floor, we skip the middle. Retailers, interior designers and hotel groups get the same craft — at the price only a direct manufacturer can offer." },
  { number: "04", title: "Custom is our default.", body: "Sizes, colourways, logos, packaging. Bring us a moodboard or a spec sheet — our design cell will develop, sample and deliver within your window." },
];

export const WHY_US = [
  { k: "Premium Materials", v: "Long-staple cottons, sateens and blends sourced from certified mills." },
  { k: "Direct Manufacturer Pricing", v: "Factory to floor. No middlemen, no markups." },
  { k: "Bulk Orders Welcome", v: "MOQ-friendly runs from 100 pieces to full container loads." },
  { k: "Custom Designs Available", v: "Colour, print, weave, size — engineered to your brief." },
  { k: "Timely Delivery", v: "Committed lead times with production tracking across every SKU." },
  { k: "Strict Quality Control", v: "Every batch inspected against a 14-point QC protocol." },
];

// Pushplinen-style star reviews
export const TESTIMONIALS_LIST = [
  {
    quote:
      "Anabiya became our contract supplier for four properties in the first quarter. Their hotel bedding holds up beautifully after industrial laundering.",
    author: "Procurement Head",
    org: "Boutique Hotel Group, Goa",
  },
  {
    quote:
      "The colour development team turned around three custom sateens in ten days. Rare to find a manufacturer that treats a small designer like a large brand.",
    author: "Founder",
    org: "Interior Studio, Bengaluru",
  },
  {
    quote:
      "Consistent GSM, honest thread counts, and delivery on the date they promise. We stock Anabiya across 22 retail doors now.",
    author: "Category Buyer",
    org: "Home Chain, Delhi NCR",
  },
];

export const REVIEWS = [
  {
    author: "Mr Daniel Labbe",
    rating: 5,
    title: "Outstanding quality and craftsmanship!",
    body:
      "Custom bench cushion arrived immaculately packaged. Sizing spot on, thickest option was the right call — incredibly comfortable, exceptional stitching. Would happily order again.",
    product: "Custom Bench Cushion",
  },
  {
    author: "Lynn B.",
    rating: 5,
    title: "Custom made as described.",
    body:
      "I was very happy with the queen bed skirt. It was custom made as described and fit perfectly. The communication to make sure I measured correctly made the difference.",
    product: "Custom Bedskirt",
  },
  {
    author: "Anonymous Verified Buyer",
    rating: 5,
    title: "Super responsive and helpful",
    body:
      "Such great help picking out these curtains! Curtains are great quality and the team walked me through every custom option.",
    product: "Ticking Stripe Border Curtains",
  },
  {
    author: "Mary Ehrhardt",
    rating: 5,
    title: "Fabric is high quality.",
    body:
      "Super fast shipping. Fabric is high quality — not see through at all. Spot on for the length requested. I am very pleased.",
    product: "Custom Bedskirt",
  },
];

export const INSTAGRAM_FEED = [
  IMG.bedding_main,
  IMG.cushions,
  IMG.curtains,
  IMG.linen,
  IMG.bath_a,
  IMG.bedroom_a,
  IMG.duvet_a,
  IMG.bedspread,
  IMG.round,
  IMG.craft,
];

export const GALLERY_IMAGES = [
  IMG.bedding_main, IMG.linen, IMG.cushions, IMG.curtains, IMG.craft, IMG.bedroom_a, IMG.bedroom_b, IMG.living_a,
];

// Announcement bar messages (rotates through)
export const ANNOUNCEMENTS = [
  "Crafted in India · Shipped worldwide",
  "Luxury bedding · Hotel linen · Custom manufacturing",
  "Trade & wholesale enquiries welcome · Serving USA · UK · Australia · UAE · Europe",
  "Same-day quote on WhatsApp · Reply within one business day",
];
